import { render, staticRenderFns } from "./LayoutMobileHeader.vue?vue&type=template&id=b4f38d96&scoped=true&"
import script from "./LayoutMobileHeader.vue?vue&type=script&lang=js&"
export * from "./LayoutMobileHeader.vue?vue&type=script&lang=js&"
import style0 from "./LayoutMobileHeader.vue?vue&type=style&index=0&id=b4f38d96&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f38d96",
  null
  
)

export default component.exports